import { InitialResolver } from "@/lib/use.middlewares";
import css from "./.module.scss";
import Icon from "@/components/icon";
import { useRouter } from "next/router";
import { Modal, Radio } from "@aqar-app/react-ui";
import { useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_ADD_LISTING_CONFIG } from "@/graphql/queries/listing";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { GET_ALL_CATEGORIES } from "@/graphql/queries/categories";
import { AddListingPopup } from "@/components/add-v2/addListingPopup";
import withAuthentication from "@/hoc/withAuthentication";
import Head from "next/head";
import { ErrorModal } from "@/components/error/ssr";

const skeletonsCategorys = new Array(10).fill(0).map((_, i) => ({
  id: i + 1,
  name: "",
}));
const MarketingRequestSelectCategoryPage = withAuthentication(
  function MarketingRequestSelectCategoryPage() {
    const { token } = useAuthState();
    const [loading, setLoading] = useState(true);

    const [getAddListingConfig] = useLazyQuery(GET_ADD_LISTING_CONFIG, {
      context: { token },
    });
    const [type, setType] = useState("all");

    const { loading: cLoading } = useQuery(GET_ALL_CATEGORIES, {
      variables: {
        lang: "ar",
        type,
      },
      onCompleted: (data) => {
        setCategories(
          data?.Web.categories?.filter(({ id }) => id !== 24) || [],
        );
        setLoading(false);
      },
    });
    const [categories, setCategories] = useState(skeletonsCategorys);

    const router = useRouter();
    return (
      <div className={css.category}>
        <Head>
          <title>اضافة طلب تسويق | اختر فئة</title>
        </Head>
        <div className={css.header}>
          <Radio
            onChange={(e) => {
              if (e.target.value === "all") {
                return setType("all");
              }
              if (e.target.value === "rent") {
                return setType("for_rent");
              }
              if (e.target.value === "sale") {
                return setType("for_sale");
              }
            }}
            button
            name="category"
            value="all"
          >
            <Radio.Option label="الكل" value="all" />
            <Radio.Option label="للإيجار" value="rent" />
            <Radio.Option label="للبيع" value="sale" />
          </Radio>
        </div>
        <div className={css.card}>
          {categories.map((category) =>
            category.id > 0 && category.id < 100 ? (
              <button
                data-loading={loading || cLoading}
                disabled={loading || cLoading}
                onClick={(e) => {
                  setLoading(true);
                  function nextStep() {
                    localStorage.removeItem("addListingStep");
                    localStorage.setItem(
                      "newListingDraft",
                      JSON.stringify({
                        category: category.id,
                      }),
                    );
                    return router.push("/add-listing/init");
                  }

                  getAddListingConfig({
                    variables: {
                      category: category.id,
                    },
                  })
                    .then(({ data }) => {
                      const { add_listing_pop_message, allow_adding } =
                        data?.Listing?.getAddingListingConfig || {};
                      if (add_listing_pop_message?.show) {
                        return Modal.open(
                          <AddListingPopup
                            {...add_listing_pop_message}
                            onNext={(e) => {
                              nextStep().then(() => Modal.close(e));
                            }}
                          />,
                        )(e);
                      }
                      return nextStep();
                    })
                    .catch(ErrorModal.handle)
                    .finally(() => setLoading(false));
                }}
                key={category.id}
              >
                {category.name ? (
                  category.name
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: ".2rem",
                      background: "#eee",
                    }}
                  />
                )}

                <Icon width={25} height={25} name="RightArrow-colored" />
              </button>
            ) : null,
          )}
        </div>
      </div>
    );
  },
);
MarketingRequestSelectCategoryPage.getInitialProps = InitialResolver(
  async (ctx) => {
    const { default: catMap } = await import(
      "@/lib/path-resolver-middlewares/ssr/categories"
    );
    ctx.path.categories = Object.keys(catMap).map((key) => catMap[key]);
  },
);
export default MarketingRequestSelectCategoryPage;
